import React, { Component } from 'react'
import { connect } from 'react-redux'

// import styles
import './pricemodellogmodal.scss'

// import components
import Modal from '../../components/Modal'
// import { hasAccess } from '../../../utils/auth'

// import utils
import { renderFullDate } from '../../../utils/time'

// Actions
import { getPriceModelLog } from '../../../actions/priceModel'

// Utils
import { translation } from '../../../utils/helpers'
import TableHeader from '../../elements/tableHeader'
import TableRow from '../../elements/tableRow'

import { ModalIcons } from '../../elements/icons'

class PriceModelLogModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      overflowHidden: false,
      price: {},
      log: [{
        ChangeTable: 0,
        ChangeTableId: 0,
        ChangeField: 0,
        PartItemId: 0,
        ChangeType: 0,
        ChangedById: 0,
        ChangedByName: null,
        ChangedAt: '',
        From: 0,
        To: 0,
        FromText: null,
        ToText: null
      }]
    }
    // this.renderForm = this.renderForm.bind(this)
    this.getPriceModelLog = this.getPriceModelLog.bind(this)
  }

  componentDidMount () {
    this.getPriceModelLog(this.props)
  }

  componentWillReceiveProps (nextProps) {
    this.getPriceModelLog(nextProps)
  }

  getPriceModelLog (props) {
    let id = props.priceModelId
    let userId = null
    let fromTime = null
    let toTime = null

    props.getPriceModelLog(id, userId, fromTime, toTime).then((res) => {
      this.setState({
        log: res.data
      })
    }, () => {
      // Toastr
      // window.toastr.error(translation('13445'), translation('216'))
      // this.props.onShouldUpdate()
    })
  }

  renderPriceModelLog () {
    // Do not render if estimation type model
    // if (this.state.price.PriceType === 5) return null
    // if (this.props.partners) {
    //   if (hasAccess([2], this.props.auth.user.UserType)) {
    //     return null
    //   }
    // }

    let log = this.state.log
    let hasData = log !== undefined

    const renderLogLine = (val, key) => {
      let changeText = translation('1868')
      let addedText = translation('1869')
      let removedText = translation('1870')

      let text = ''
      let fieldName = ''
      let tableName = ''
      let fromVal = ''
      let toVal = ''
      if (val.FromText !== null && val.FromText !== '') {
        fromVal = val.FromText
        if (val.ChangeField === 18 || val.ChangeField === 23) {
          fromVal = (fromVal === 'True') ? translation('13553') : translation('13554')
        }
      } else {
        fromVal = val.From
      }
      if (val.ToText !== null && val.ToText !== '') {
        toVal = val.ToText
        if (val.ChangeField === 18 || val.ChangeField === 23) {
          toVal = (toVal === 'True') ? translation('13553') : translation('13554')
        }
      } else {
        toVal = val.To
      }

      let changedBy = val.ChangedByName
      let changedTime = val.ChangedAt

      switch (val.ChangeTable) {
        case 0:
          tableName = ''
          break
        case 1:
          tableName = translation('1867')
          break
        case 2:
          tableName = translation('1227')
          break
        case 3:
          tableName = translation('13344')
          break
        case 4:
          tableName = translation('13374')
          break
        case 12:
          tableName = translation('1871')
          break
        case 13:
          tableName = translation('1872')
          break
      }

      switch (val.ChangeField) {
        case 1:
          fieldName = translation('30')
          break
        case 2:
          fieldName = translation('295')
          break
        case 9:
          fieldName = translation('419')
          break
        case 10:
          fieldName = translation('13443')
          break
        case 11:
          fieldName = translation('1044')
          break
        case 12:
          fieldName = translation('1199')
          break
        case 13:
          fieldName = translation('885')
          break
        case 14:
          fieldName = translation('13350')
          break
        case 15:
          fieldName = translation('13431')
          break
        case 16:
          fieldName = translation('1305')
          break
        case 17:
          fieldName = translation('393')
          break
        case 18:
          fieldName = translation('13477')
          break
        case 19:
          fieldName = translation('13477')
          break
        case 22:
          fieldName = translation('13476')
          break
        case 23:
          fieldName = translation('13476')
          break
        case 24:
          fieldName = translation('16673')
          break
      }

      switch (val.ChangeType) {
        case 1:
          text = changeText
          break
        case 2:
          text = removedText
          break
        case 0:
          text = addedText
          break
      }
      // console.log('Text', text)

      text = text.replace('[table]', tableName)
      text = text.replace('[field]', fieldName)
      text = text.replace('[fromvalue]', fromVal)
      text = text.replace('[tovalue]', toVal)
      text = text.replace('[user]', changedBy)
      text = text.replace('[time]', changedTime)

      return (
        <TableRow cols={cols} key={key}>
          <div>{renderFullDate(changedTime)}</div>
          <div>{changedBy}</div>
          <div>{text}</div>
        </TableRow>
      )
    }

    const cols = [ 1, 1, 2 ]

    return (
      <div>
        <TableHeader expand>
          {translation('1866')}
        </TableHeader>

        <TableRow header cols={cols} align='center'>
          <div>{translation('388')}</div>
          <div>{translation('30')}</div>
          <div>{translation('1489')}</div>
        </TableRow>

        {hasData && log.map(renderLogLine)}
      </div>
    )
  }

  render () {
    return (
      <div className='pricelog_modal'>
        <Modal {...this.props} header={translation('1864')} overflowHidden={this.state.overflowHidden}
          icon={ModalIcons.Plus}>
          {this.renderPriceModelLog()}
        </Modal>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getPriceModelLog,
  renderFullDate
})(PriceModelLogModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/PriceModelLogModal/index.js